import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BootstrapTable from 'react-bootstrap-table-next';
import { useParams } from 'react-router-dom';
import filterFactory, { textFilter, selectFilter, dateFilter, numberFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import useToken from '../../App/useToken';
import './StudentCourseTable.css';

const unitSpcs = require('../../utils/UnitSpcJson');
const units = require('../../utils/UnitJson');
const spcs = require('../../utils/SpcJson');

let nameFilter;
let unitFilter;
let unitSpcFilter;
let spcFilter;
let passQualificationFilter;
let unitPositionFilter;
let unitSpcPositionFilter;
let degreeAbbrNameFilter;
let bornEduNameFilter;
let seniorOfRankFilter;
let ageFilter;
let eclFilter;
let seqFilter;
let healthFilter;
let unitOrderFilter;
let spcOrderFilter;
let orderFilter;
let unitTermFilter;
let spcTermFilter;
let termFilter;
let startDateFilter;

export default function StudentCourseTable({ studentCourses, handleStudentChangeTermModalShow, role, terms, isSpcApprove, setActiveTerm, isStudentAll, handlePassQualificationClick, activeTerm }) {
  const { major_name } = useParams();
  const [count, setCount] = useState();
  const [unitCount, setUnitCount] = useState();
  const [spcCount, setSpcCount] = useState();  
  const [unitSpcCount, setUnitSpcCount] = useState();
  const { isAdmin, isUnitAdminOrUnitSpcAdmin, isUnitSpcAdmin, isUnitAdmin, isAdminViewer } = useToken();
  const isUserAdminViewer = isAdminViewer();
  const isUserAdmin = isAdmin();
  const isUserUnitAdminOrUnitSpcAdmin = isUnitAdminOrUnitSpcAdmin();
  const isUserUnitSpcAdmin = isUnitSpcAdmin();
  const isUserUnitAdmin = isUnitAdmin();
  const isNotSosCourse = major_name != 'หลักสูตรนายทหารชั้นผู้บังคับฝูง';
  useEffect(() => {
    setCount('');
  }, [activeTerm]);
  const rowEvents = {
      onClick: (e, row, rowIndex) => {
        handleStudentChangeTermModalShow({ ...row, index: rowIndex, temp_term: terms[rowIndex]?.id })
      }
    };

    const rowClasses = (row) => {
      let classes = '';
      switch (role) {
        case 'admin':
          if (!row.is_pass_qualification) {
            classes = 'table-danger ';
          }
          break;
        case 'adminViewer':
          if (!row.is_pass_qualification) {
            classes = 'table-danger';
          }
          break;
        case 'adminUnit':
          if (!row.unit_is_pass_qualification) {
            classes = 'table-danger';
          }
          break;
        case 'adminUnitSpc':
          if (!row.spc_is_pass_qualification) {
            classes = 'table-danger';
          }  
          break;
      }
      classes += `${row._id} ${row.airforceId} ${row.unit_no} ${row.spcNo} ${row.unitSpcNo} ${row.is_soft_qualification ? 'soft-qualified' : ''}`;
    
      return classes;
    };

    function isTextNotNull(txt) {
      return(txt != undefined && txt != null && txt != '');
    }

    function indexFormatter(cell, row) {
      let display = cell;
      if (isUserAdmin || isUserUnitAdminOrUnitSpcAdmin || isUserAdminViewer) {
        if (isTextNotNull(row.note)) display += ' *';
        if (isTextNotNull(row.spc_note)) display += ' *';
        if (isTextNotNull(row.unit_note)) display += ' *';
      } else if (isUserUnitSpcAdmin) {
        if (isTextNotNull(row.spc_note)) display += ' *';
        if (isTextNotNull(row.unit_note)) display += ' *';
      } else if (isUserUnitAdmin && isTextNotNull(row.unit_note)) {
        display += ' *';
      }
      return display;
    }
    
    const columns = [
      {
        dataField: 'is_pass_qualification',
        headerClasses: 'qualification',
        text: 'คุณสมบัติ',
        filter: textFilter({
          getFilter: (filter) => {
            passQualificationFilter = filter;
          }
        }),
        formatter: (cell) => {
          return cell ? 'ผ่าน' : 'ไม่ผ่าน';
        }
      },
      {
        dataField: 'index',
        headerClasses: 'index',
        text: '#',
        sort: true,
        formatter: indexFormatter
      }, {
        dataField: 'rankAbbrName',
        headerClasses: 'rank-abbr-name',
        text: 'ยศ',
        sort: true
      }, {
        dataField: 'fullName',
        headerClasses: 'full-name',
        text: 'ชื่อ-นามสกุล',
        filter: textFilter({
          getFilter: (filter) => {
            nameFilter = filter;
          }
        })
      }, {
        dataField: 'unit_no',
        headerClasses: 'org-abbr-name',
        text: `นขต.ทอ. ${(unitCount != studentCourses.length && unitCount != undefined) ? '('+unitCount+')' : ''}`,
        formatter: cell => units[cell],
        filter: selectFilter({
          getFilter: (filter) => {
            unitFilter = filter;
          },
          options: units,
          onFilter: (filterValue, rows) => {
            const filter = rows.filter(e => e.unit_no == filterValue);
            setUnitCount(filter.length);
            if(filterValue == '') setUnitCount(studentCourses.length);
          }
        })
      }, {
        dataField: 'unitSpcNo',
        headerClasses: 'unit-spc-no',
        text: `หน่วย หน.สายวิทยาการ ${(unitSpcCount != studentCourses.length && unitSpcCount != undefined) ? '('+unitSpcCount+')' : ''}`,
        formatter: cell => unitSpcs[cell],
        filter: selectFilter({
          getFilter: (filter) => {
            unitSpcFilter = filter;
          },
          options: unitSpcs,
          onFilter: (filterValue, rows) => {
            const filter = rows.filter(e => e.unitSpcNo == filterValue);
            setUnitSpcCount(filter.length);
            if(filterValue == '') setUnitSpcCount(studentCourses.length);
          }
        })
      }, {
        dataField: 'spcNo',
        headerClasses: 'spc-name',
        text: `สายวิทยาการ ${(spcCount != studentCourses.length && spcCount != undefined) ? '('+spcCount+')' : ''}`,
        formatter: cell => spcs[cell],
        filter: selectFilter({
          getFilter: (filter) => {
            spcFilter = filter;
          },
          options: spcs,
          onFilter: (filterValue, rows) => {
            const filter = rows.filter(e => e.spcNo == filterValue);
            setSpcCount(filter.length);
            if(filterValue == '') setSpcCount(studentCourses.length);
          }
        })
      }, {
        dataField: 'age',
        headerClasses: 'age',
        text: 'อายุ',
        filter: numberFilter({
          getFilter: (filter) => {
            ageFilter = filter;
          }
        }),
        sort: true
      }, {
        dataField: 'pme_data.START_DATE', 
        // dataField: 'startDateTh', 
        headerClasses: 'start-date',
        text: 'วันที่บรรจุ',
        filter: dateFilter(),
        // filter: textFilter({
        //   getFilter: (filter) => {
        //     startDateFilter = filter;
        //   }
        // }),
        sort: true,
        formatter: (cell) => {
          const d = new Date(cell);
          return cell ? d.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
					  day: 'numeric'
          }) : '-';
        }
      }, {
        dataField: 'seniorOfRank',
        headerClasses: 'senior-of-rank',
        text: 'ระยะเวลาการครองยศ',
        sort: true,
        filter: numberFilter({
          getFilter: (filter) => {
            seniorOfRankFilter = filter;
          }
        })
      }, {
        dataField: 'bornEduName',
        headerClasses: 'born-edu',
        text: 'คุณวุฒิที่ใช้บรรจุ',
        filter: textFilter({
          getFilter: (filter) => {
            bornEduNameFilter = filter;
          }
        }),
        sort: true
      }, {
        dataField: 'degreeAbbrName',
        headerClasses: 'degree-abbr',
        text: 'คุณวุฒิสูงสุด',
        filter: textFilter({
          getFilter: (filter) => {
            degreeAbbrNameFilter = filter;
          }
        }),
        sort: true
      }, {
        dataField: 'ecl_score',
        headerClasses: 'ecl-score',
        text: 'คะแนนภาษาอังกฤษ',
        sort: true,
        filter: numberFilter({
          getFilter: (filter) => {
            eclFilter = filter;
          }
        }),
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'health',
        headerClasses: 'health',
        text: 'ผลการตรวจร่างกาย',
        sort: true,
        formatter: (cell) => {
          if (cell == undefined) {
            return '-';
          }
          return cell ? 'ผ่าน' : 'ไม่ผ่าน';
        },
        filter: selectFilter({
          options: { true: 'ผ่าน', false: 'ไม่ผ่าน' },
          getFilter: (filter) => {
            healthFilter = filter;
          }
        })
      }
    ];
    if ((isUserUnitAdminOrUnitSpcAdmin || isUserAdmin || isUserAdminViewer) && isSpcApprove && isNotSosCourse ) {
      columns.push({
        dataField: 'pme_data.YEAR_SUCCESS_SOS',
        headerClasses: 'year-success-sos',
        text: 'ปีจบ นฝ.',
        filter: numberFilter(),
        sort: true
      } );
    }
    if (isUserUnitAdmin) {
      columns.push({
        dataField: 'positionAddDateUnit',
        headerClasses: 'position-add-date-unit',
        text: 'สิทธิ์เข้าอัตราหน่วย',
        sort: true,
        formatter: (cell) => {
          const d = new Date(cell);
          return cell ? d.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
          }) : '-';
        }
      },
      );
    }
    if (isUserUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
      columns.push({
        dataField: 'levelUpPlanUnitText',
        headerClasses: 'level-up-plan-unit',
        text: 'แผนสิทธิ์เข้าอัตราหน่วย',
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'levelUpPlanUnitSpcText',
        headerClasses: 'level-up-plan-unit-spc',
        text: 'แผนสิทธิ์เข้าอัตราสาย',
        formatter: (cell) => {
          return cell || '-';
        }
      },{
        dataField: 'positionAddDateUnit',
        headerClasses: 'position-add-date-unit',
        text: 'สิทธิ์เข้าอัตราหน่วย',
        sort: true,
        formatter: (cell) => {
          const d = new Date(cell);
          return cell ? d.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
          }) : '-';
        }
      }, {
        dataField: 'positionAddDateUnitSpc',
        headerClasses: 'position-add-date-unit-spc',
        text: 'สิทธิ์เข้าอัตราสาย',
        // filter: dateFilter(),
        sort: true,
        formatter: (cell) => {
          const d = new Date(cell);
          return cell ? d.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
          }) : '-';
        }
      },
      );
    }
    if (isUserUnitAdminOrUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
      columns.push({
        dataField: 'unit_order',
        headerClasses: 'unit-order',
        text: 'ลำดับหน่วย',
        filter: numberFilter({
          getFilter: (filter) => {
            unitOrderFilter = filter;
          }
        }),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if ((isUserAdminViewer || isUserAdmin || isUserUnitSpcAdmin) && isSpcApprove) {
      columns.push({
        dataField: 'spc_order',
        headerClasses: 'spc-order',
        text: 'ลำดับสาย',
        filter: numberFilter({
          getFilter: (filter) => {
            spcOrderFilter = filter;
          }
        }),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if (isUserAdmin || isUserAdminViewer) {
      columns.push({
        dataField: 'order',
        headerClasses: 'order',
        text: 'ลำดับ กพ.',
        filter: numberFilter({
          getFilter: (filter) => {
            orderFilter = filter;
          }
        }),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if (isUserUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
      columns.push({
        dataField: 'unit_term_text',
        headerClasses: 'unit-term',
        text: 'รุ่นหน่วย',
        sort: true,
        filter: textFilter({
          getFilter: (filter) => {
            unitTermFilter = filter;
          }
        }),
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if ((isUserAdmin || isUserAdminViewer) && isSpcApprove) {
      columns.push({
        dataField: 'line_term_text',
        headerClasses: 'line-term',
        text: 'รุ่นสาย',
        filter: textFilter({
          getFilter: (filter) => {
            spcTermFilter = filter;
          }
        }),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if (isUserUnitSpcAdmin && isSpcApprove) {
      columns.push({
        dataField: 'line_term_text',
        headerClasses: 'line-term',
        text: 'รุ่นสาย',
        filter: textFilter({
          getFilter: (filter) => {
            spcTermFilter = filter;
          }
        }),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'spc_is_pass_qualification_text',
        headerClasses: 'spc-is-pass-qualification-text',
        classes: 'spc-is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-';
        }
      }, 
      {
        dataField: 'line_term',
        headerClasses: 'status',
        classes: 'status',
        text: 'สถานะ',
        sort: true,
        formatter: (cell) => {
          const returnText = (cell != '0' && cell != '1') ? 'ส่งแล้ว' : '-'
          return returnText;
        }
      });
    }
    if (isUserAdmin || isUserAdminViewer) {
      columns.push({
        dataField: 'term_text',
        headerClasses: 'term',
        filter: textFilter({
          getFilter: (filter) => {
            termFilter = filter;
          }
        }),
        text: 'สรุปรุ่น',
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'is_pass_qualification_text',
        headerClasses: 'is-pass-qualification-text',
        classes: 'is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'note',
        headerClasses: 'note',
        classes: 'note',
        text: 'หมายเหตุ',
        formatter: (cell) => {
          return cell || '-';
        }
      });
    }
    if (role === 'adminUnit') {
      columns.push({
        dataField: 'unit_term_text',
        headerClasses: 'unit-term',
        text: 'รุ่นหน่วย',
        filter: textFilter({}),
        sort: true,
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'unit_is_pass_qualification_text',
        headerClasses: 'unit-is-pass-qualification-text',
        classes: 'unit-is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-';
        }
      }, {
        dataField: 'unit_term',
        headerClasses: 'status',
        classes: 'status',
        text: 'สถานะ',
        sort: true,
        formatter: (cell) => {
          const returnText = (cell != '0' && cell != '1') ? 'ส่งแล้ว' : '-'
          return returnText;
        }
      });
    }

    const clearFilter = () => {
      nameFilter('');
      degreeAbbrNameFilter('');
      bornEduNameFilter('');
      seniorOfRankFilter('');
      unitFilter();
      spcFilter();
      unitSpcFilter();
      unitPositionFilter('');
      unitSpcPositionFilter('');
      passQualificationFilter();
      setSpcCount();
      setUnitCount();
      ageFilter('');
      eclFilter('');
      seqFilter('');
      healthFilter();
      unitOrderFilter('');
      spcOrderFilter('');
      orderFilter('');
      unitTermFilter('');
      spcTermFilter('');
      termFilter('');
      startDateFilter('');
    };

    const afterFilter = (newResult, newFilters) => {
      setCount(newResult.length);
    }

    const options = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: 'First',
      prePageText: 'Back',
      nextPageText: 'Next',
      lastPageText: 'Last',
      nextPageTitle: 'First page',
      prePageTitle: 'Pre page',
      firstPageTitle: 'Next page',
      lastPageTitle: 'Last page',
      showTotal: true,
      hideSizePerPage: true,
      disablePageTitle: true
    };

    return (
      <div className='std-table'>
        { studentCourses != [] && <Tabs>
          <TabList>
            {terms.map((term, index) => (
              <Tab key={term.id} onClick={() => setActiveTerm(index)}>
                <span>{term.prefix} {term.name} ({term.suffixAmount})</span>
              </Tab>
            ))}
          </TabList>

          {studentCourses.map((studentCourse, index) => (
            <>
              { terms.length > 0 && <TabPanel key={index}>
                <span className='student-count'>จำนวนตามที่คัดกรอง : {count} {(count) ? 'คน' : '' }</span>
                <div className='btn-container-table'>
                  <button className="btn btn-sm btn-primary btn-clear" onClick={ clearFilter }> ล้างตัวกรองทั้งหมด </button>
                  { (isUserUnitAdminOrUnitSpcAdmin || isUserAdmin) &&  
                    <button className="btn btn-sm btn-primary hide-show-qualification" onClick={ handlePassQualificationClick }>
                        {isStudentAll ? 'แสดงเฉพาะผู้ผ่านคุณสมบัติ' : 'แสดงทั้งหมด'}
                    </button>
                  }
                </div>
                  {/* <button className="btn btn-sm btn-primary btn-pass-qualification" onClick={ handlePassQualificatioClick }> ผู้ผ่านคุณสมบัตร </button> */}
                <BootstrapTable 
                  rowEvents={rowEvents}
                  rowClasses={ rowClasses }
                  striped 
                  hover 
                  bordered={ false } 
                  keyField='id' 
                  data={ studentCourse.data }
                  columns={ columns } 
                  filter={ filterFactory({ afterFilter }) }
                  noDataIndication='-----ไม่พบข้อมูล-----'
                  bootstrap4
                  key={index}
                  classes='student-course-table'
                  pagination={ paginationFactory({...options, sizePerPageList: [{
                    text: '50', value: 50
                  }, {
                    text: '100', value: 100
                  }, {
                    text: 'All', value: studentCourse.data.length
                  }] }) }
                />
              </TabPanel>}
            </>
          ))}
        </Tabs> }
      </div>
    );
}